import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../utilities/auth/authUtils";

// --- CSS --- //
import "../../styles/header-user.css";

// --- ASSETS --- //
import logo from "../../assets/vert-cert-logo.png";
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium"; // For Certifications
import MapIcon from "@mui/icons-material/Map"; // For Map
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from '@mui/icons-material/Home';

// --- COMPONENTS --- //
import Dropdown from "../Dropdown";

const Header_User = () => {
    // State to toggle dropdown visibility
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const navigate = useNavigate();

    // Toggle dropdown handler
    const toggleDropdown = () => {
        setIsDropdownVisible((prev) => !prev);
    };

    // Updated dropdown menu items
    const dropdownItems = [
        { icon: <HomeIcon />, title: "HOME", link: "/" },
        { icon: <AccountCircleIcon />, title: "Profile", link: "/my-profile" },
        { icon: <WorkspacePremiumIcon />, title: "Certifications", link: "/my-certs" },
        { icon: <MapIcon />, title: "Map", link: "/my-map" },
        { icon: <LogoutIcon />, title: "Logout", onClick: () => handleLogout(navigate), style: { color: "var(--button-delete-bg)" } },
    ];

    return (
        <>
            {/* HEADER */}
            <div id="header-container">
                {/* LOGO */}
                <div id="logo-container">
                    <a href="/"><img src={logo} alt="Vert Cert Logo" /></a>
                </div>

                {/* ACCOUNT ICON */}
                <div id="account-dropdown-container">
                    <span onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                        <MenuIcon style={{ fontSize: 40, color: "var(--text-primary)" }} />
                    </span>
                </div>
            </div>

            {/* DROPDOWN MENU */}
            {isDropdownVisible && (
                <Dropdown
                    items={dropdownItems.map((item) => ({
                        ...item,
                        onClick: item.onClick
                            ? item.onClick
                            : () => navigate(item.link), // Default navigation handler
                    }))}
                />
            )}
        </>
    );
};

export default Header_User;